 
import React from 'react';
import {Link} from 'react-router';
import {stepMap} from '../HelperFunctions';

const ReviewSkipItem = ({name, index}) => {
    const url = stepMap[name];

    return (
        <Link key={index} to={url} className="bridle-piece">
            <span className="icon skip-check">
                <span className="sr-only">{name} added</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm141.421 106.579c73.176 73.175 77.05 187.301 15.964 264.865L132.556 98.615c77.588-61.105 191.709-57.193 264.865 15.964zM114.579 397.421c-73.176-73.175-77.05-187.301-15.964-264.865l280.829 280.829c-77.588 61.105-191.709 57.193-264.865-15.964z"></path></svg>
            </span>
            <span className="skip-product">
                {name}: No {name}
            </span>
        </Link>
    );
};

export default ReviewSkipItem;
